import { ComponentType } from 'react';

import { useDataSyncing } from '@dreryk/command-query-react-common';
import {
   ActionBar,
   ActionBarElementType,
   DataSyncWaitingEventInterceptor,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import { VideoConsultationEndShowEventInterceptor } from '~libs.desktop.video-consultation';

import visitSettlement from '../../../../visitSettlement';
import { VisitFormController, VisitFormSubmitHandler } from '../../visitForm.types';
import { CheckExistingEzwmDraftsShowModalEventInterceptor } from '../shared/CheckExistingEzwmDraftsShowModalEventInterceptor';
import { NotAcceptedPrescriptionShowModalEventInterceptor } from '../shared/NotAcceptedPrescriptionShowModalEventInterceptor';
import { visitDetailsTranslationKeys } from '../../../../translations';

import { ConfirmVisitSummaryActionProps } from './ConfirmVisitSummaryAction';
import { PrintsShowModalEventInterceptor } from './interceptors/PrintsShowModalEventInterceptor';

export const withConfirmVisitSummaryActionInterceptors = (Component: ComponentType<ConfirmVisitSummaryActionProps>) => (
   props: Pick<VisitFormController, 'control' | 'trigger'> & {
      readonly handleSubmit: VisitFormSubmitHandler;
      readonly visitId: number;
      readonly appointmentId: number;
      readonly patientId: number;
   }
): JSX.Element => {
   return (
      <ActionBar.Portal elementType={ActionBarElementType.PRIMARY}>
         <VideoConsultationEndShowEventInterceptor
            appointmentId={props.appointmentId}
            content={visitDetailsTranslationKeys.approveVisitForWhichVideoConsultationIsInProgress}
         >
            <DataSyncWaitingEventInterceptor waitUntil={useDataSyncing()}>
               {(waiting) => (
                  <ValidateFormEventInterceptor trigger={props.trigger}>
                     <visitSettlement.MedicalServicesUpdateEventInterceptor
                        appointmentId={props.appointmentId}
                        control={props.control}
                     >
                        <NotAcceptedPrescriptionShowModalEventInterceptor visitId={props.visitId}>
                           <CheckExistingEzwmDraftsShowModalEventInterceptor visitId={props.visitId}>
                              <PrintsShowModalEventInterceptor
                                 visitId={props.visitId}
                                 patientId={props.patientId}
                                 handleSubmit={props.handleSubmit}
                              >
                                 <Component waiting={waiting} />
                              </PrintsShowModalEventInterceptor>
                           </CheckExistingEzwmDraftsShowModalEventInterceptor>
                        </NotAcceptedPrescriptionShowModalEventInterceptor>
                     </visitSettlement.MedicalServicesUpdateEventInterceptor>
                  </ValidateFormEventInterceptor>
               )}
            </DataSyncWaitingEventInterceptor>
         </VideoConsultationEndShowEventInterceptor>
      </ActionBar.Portal>
   );
};
